import { Controller } from "@hotwired/stimulus"

// Banner-Picker für Coworkr-Newsletter-Kampagnen:
// - Klick auf existierende Banner-Card → setzt versteckten banner_id, highlightet die Card,
//   leert Upload-Feld.
// - File-Upload → leert banner_id (Card-Highlight aus), zeigt Bild-Preview.
//   Server-Code im Controller wandelt den Upload in einen BannerGenerator::Banner und
//   weist ihn der NS zu.
export default class extends Controller {
  static targets = ["bannerIdInput", "uploadInput", "card", "preview", "previewImage"]

  connect() {
    this._highlightSelected()
  }

  select(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.bannerId
    this.bannerIdInputTarget.value = id
    if (this.hasUploadInputTarget) this.uploadInputTarget.value = ""
    this._clearPreview()
    this._highlightSelected()
  }

  clear(event) {
    event?.preventDefault()
    this.bannerIdInputTarget.value = ""
    if (this.hasUploadInputTarget) this.uploadInputTarget.value = ""
    this._clearPreview()
    this._highlightSelected()
  }

  upload(event) {
    const file = event.currentTarget.files[0]
    if (!file) return
    this.bannerIdInputTarget.value = ""
    this._highlightSelected()
    if (this.hasPreviewImageTarget) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewImageTarget.src = e.target.result
        if (this.hasPreviewTarget) this.previewTarget.classList.remove("d-none")
      }
      reader.readAsDataURL(file)
    }
  }

  _highlightSelected() {
    const id = this.bannerIdInputTarget.value
    this.cardTargets.forEach(card => {
      card.classList.toggle("banner-picker__card--selected", card.dataset.bannerId === id && id !== "")
    })
  }

  _clearPreview() {
    if (this.hasPreviewImageTarget) this.previewImageTarget.src = ""
    if (this.hasPreviewTarget) this.previewTarget.classList.add("d-none")
  }
}
